/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c19cab1662745293e5bf052395df909>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/rovo-chat
 * Usage guidance:
 * Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const RovoChatIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "RovoChatIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
RovoChatIcon.displayName = 'RovoChatIcon';
var _default = exports.default = RovoChatIcon;